<template>
    <ExtendedLayout
        :project="project"
        currentTab="table-data"
    >

        <Panel>

            <form @submit.prevent="submit">

                <ProjectFeedSelector
                    v-if="project.type === 'multi_feed'"
                    :project="project"
                    :selectedFeedId="selectedFeedId"
                    @select="selectedFeedId = $event"
                />

                <div class="divide-y divide-gray-200 mb-4">
                    <div
                        v-for="(name, key) in tableColumnOptions"
                        class="grid grid-cols-12 gap-4 py-4"
                    >
                        <FormGroup class="col-span-2" slim>
                            <label class="block text-sm font-bold pb-2 truncate">{{ name }}</label>
                            <Toggle v-model:checked="currentColumns[key].enabled" class="mt-2" />
                        </FormGroup>
                        <FormGroup class="col-span-2" slim>
                            <label class="block text-sm font-medium pb-2">{{ __('admin::labels.width') }}</label>
                            <Input type="number" step="1" v-model="currentColumns[key].width" :required="false" />
                        </FormGroup>
                        <FormGroup class="col-span-6" slim>
                            <label class="block text-sm font-medium pb-2">{{ __('admin::labels.label') }}</label>
                            <Input type="text" v-model="currentColumns[key].label" :required="false" :placeholder="name" />
                        </FormGroup>

                        <FormGroup class="col-span-2" slim>
                            <label class="block text-sm font-medium pb-2">{{ __('admin::labels.list_order') }}</label>
                            <Input type="number" step="1" v-model="currentColumns[key].list_order" :required="false" />
                        </FormGroup>
                    </div>
                </div>

                <Button :loading="form.processing">
                    {{ __('admin::general.update_model', {'model': __('admin::projects.project').toLowerCase() }) }}
                </Button>

            </form>

        </Panel>

    </ExtendedLayout>
</template>

<script>
import ExtendedLayout from '@/Pages/Projects/Edit';
import Panel from "@/Components/Panel";
import Button from "@/Components/Button";
import FormGroup from "@/Components/FormGroup";
import Input from "@/Components/Input";
import Toggle from "@/Components/Toggle";
import ProjectFeedSelector from "@/Components/ProjectFeedSelector.vue";

export default {
    components: {
        ProjectFeedSelector,
        Toggle,
        Input,
        FormGroup,
        Button,
        Panel,
        ExtendedLayout,
    },
    props: {
        errors: Object,
        project: Object,
        tableColumnOptions: Object,
        tableData: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                columns: {},
                feeds: [],
            }),
            selectedFeedId: null,
        }
    },
    computed: {
        currentColumns() {
            if (this.selectedFeedId === null) {
                return this.form.columns;
            }

            return this.form.feeds.find((x) => x.feed_id === this.selectedFeedId).columns;
        },
    },
    created() {
        this.form.columns = this.mapTableData(this.project.table_data);

        this.project.feeds.forEach((feed) => {
            this.form.feeds.push({
                feed_id: feed.id,
                columns: this.mapTableData(feed.table_data),
            });
        })
    },
    methods: {
        mapTableData(tableData) {
            tableData = tableData || {};
            let columns = {};

            for (let key in this.tableColumnOptions) {
                columns[key] = {
                    enabled: tableData[key]?.enabled || false,
                    width: tableData[key]?.width || '',
                    label: tableData[key]?.label || '',
                    list_order: tableData[key]?.list_order || '',
                }
            }

            return columns;
        },
        submit() {
            this.form
                .transform((data) => ({
                    ...data,
                    _method: 'patch',
                }))
                .post(this.$route('admin::projects.table-data.update', { project: this.project.id }));
        }
    },
}
</script>
